import { getAllReservationsCountUrl, getCountOfReservationsByWorkshopIdUrl, getPaginatedReservationsUrl, getReservationsByWorkshopIdUrl, getReservationUrl, updateReservationSeenStatusUrl, updateReservationStatusUrl } from "../../../shared/constants/apiUrls";
import { baseApi } from "./baseApi";

export const reservationApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getReservations: builder.query({
            query: (id) => ({
                url: `${getReservationUrl}/${id}`,
                method: 'GET',
            }),
            providesTags: [{ type: "Reservation", id: "RESERVATIONS" }],
        }),
        getReservationsByWorkshopId: builder.query({
            query: ({workshopId, limit, nextToken }) => ({
                url: `${getReservationsByWorkshopIdUrl}`,
                method: 'POST',
                data: { workshopId, limit, nextToken }
            }),
            extraOptions: { private: true },
            providesTags: [{ type: "Reservation", id: "RESERVATIONS" }],
        }),
        getPaginatedReservations: builder.query({
            query: ({ limit, nextToken }) => ({
                url: `${getPaginatedReservationsUrl}`,
                method: 'POST',
                data: { limit, nextToken }
            }),
            extraOptions: { private: true },
            providesTags: [{ type: "Reservation", id: "RESERVATIONS" }],
        }),
        getAllReservationsCount: builder.query({
            query: () => ({
                url: `${getAllReservationsCountUrl}`,
                method: 'GET'
            }),
            extraOptions: { private: true },
            providesTags: [{ type: "Reservation", id: "RESERVATIONS_COUNT" }],
        }),
        updateReservationStatus: builder.mutation({
            query: ({ reservationId, workshopId, newStatus }) => ({
                url: `${updateReservationStatusUrl}`,
                method: 'PUT',
                data: { reservationId, workshopId, newStatus },
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Reservation", id: "RESERVATIONS" }, { type: "Reservation", id: "WORKSHOP_RESERVATIONS_COUNT" }],
        }),
        getCountOfReservationsByWorkshopId: builder.query({
            query: ({ workshopId }) => ({
                url: `${getCountOfReservationsByWorkshopIdUrl}`,
                method: 'POST',
                data: { workshopId }
            }),
            extraOptions: { private: true },
            providesTags: [{ type: "Reservation", id: "WORKSHOP_RESERVATIONS_COUNT" }],
        }),
        updateReservationSeenStatus: builder.mutation({
            query: ({ reservationId, workshopId, seenStatus }) => ({
                url: `${updateReservationSeenStatusUrl}`,
                method: 'PUT',
                data: { reservationId, workshopId, seenStatus },
            }),
            extraOptions: { private: true },
            invalidatesTags: [{ type: "Reservation", id: "RESERVATIONS" }, { type: "Reservation", id: "WORKSHOP_RESERVATIONS_COUNT" }],
        }),
    }),
})

export const { useLazyGetReservationsQuery, useLazyGetReservationsByWorkshopIdQuery, useLazyGetPaginatedReservationsQuery, useGetAllReservationsCountQuery, useUpdateReservationStatusMutation, useGetCountOfReservationsByWorkshopIdQuery, useUpdateReservationSeenStatusMutation } = reservationApi;